module.exports = __webpack_public_path__ + "media/images/bg_diamond-blue-fc1b43c9311a8b4c5f89bba038eaab8b.jpg";